const items = [
  {
    num: '01',
    label: 'PROFESSIONAL PRESENCE',
    title: 'Online resumes',
    description:
      'Private custom micro pages with portfolios, contact forms, analytics, SEO, and custom domains.',
  },
  {
    num: '02',
    label: 'PRE-LAUNCH GROWTH',
    title: 'Referral waitlists',
    description:
      'Collect emails, track progress, reward referrals, and notify your audience when it is time to launch.',
  },
  {
    num: '03',
    label: 'CAMPAIGN CONVERSION',
    title: 'PPC landing pages',
    description: 'Build mobile-optimized campaign pages with analytics, testing, and monetization support.',
  },
];

export function MoreWaysSection() {
  return (
    <section className="solutions shell" id="solutions">
      <div className="section-heading fade-up">
        <span className="kicker">MORE WAYS TO LAND</span>
        <h2>
          One platform.
          <br />
          <em>More possibilities.</em>
        </h2>
        <p>
          Launch a new product, put your experience online, or turn campaign traffic into
          measurable action.
        </p>
      </div>
      <div className="solution-row fade-up">
        {items.map(item => (
          <a href="/more" key={item.num}>
            <span className="solution-num">{item.num}</span>
            <div>
              <small>{item.label}</small>
              <h3>{item.title}</h3>
              <p>{item.description}</p>
            </div>
            <b>&#8599;</b>
          </a>
        ))}
      </div>
    </section>
  );
}
